import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';

export function RedirectHome() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Preserve search params when redirecting from /auth/login to /
    const searchParams = new URLSearchParams(location.search);
    const searchString = searchParams.toString();
    const targetPath = searchString ? `/?${searchString}` : '/';
    navigate(targetPath, { replace: true });
  }, [navigate, location.search]);

  return null;
}

export function RedirectClientHome() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/client/home', { replace: true });
  }, [navigate]);

  return null;
}
